export const API_URL = process.env.REACT_APP_BASE_URL;
export const WORDPRESS_URL = process.env.REACT_APP_WORDPRESS_BASE_URL;
export const WORDPRESS_USERNAME = process.env.REACT_APP_WORDPRESS_USERNAME;
export const WORDPRESS_PASSWORD = process.env.REACT_APP_WORDPRESS_PASSWORD;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const STRIPE_TEST_KEY = process.env.REACT_APP_STRIPE_TEST_KEY;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const END_POINTS = {
  signUp: "sendOtp",
  verifyotp: "verifyotp",
  login: "login",
  mediaUpload: "upload",
  profile: "profile",
  forgotPassword: "forgotpassword",
  resetPassword: "setPassword",
  getProfile: "getProfile",
  justSendOtp: "justSendOtp",
  justVerifyOtp: "justVerifyOtp",
  changepassword: "changepassword",
  logout: "logout",
  deleteAccount: "deleteAccount",
  socialLogin: "socialLogin",
  updateGuestProfile: "updateGuestProfile",

  // home
  dashboard: "dashboard",
  banner: "banner",
  recommended: "recommended",
  featuredProd: "featuredProd",
  recentProduct: "recentProduct",

  recentProducts: "recentProducts",
  guestLogin: "guestLogin",
  globalSearch: "globalSearch",
  getProduct: "getProduct",
  getProfileById: "getProfileById",
  addWishlist: "addWishList",
  getWishlist: "getWishList",
  category: "category",
  getProductsByCategoryId: "getProductsByCategoryId",
  subCategory: "subCategory",
  follow: "follow",
  followList: "followList",
  makeAnOffer: "makeAnOffer",
  saveSearchHistory: "saveSearchHistory",
  searchHistory: "searchHistory",
  clearSearch: "clearSearch",
  featuredProducts: "featuredProducts",
  subscribeNewsletter: "subscribeNewsletter",

  //add product
  addProduct: "addProduct",
  getMyProduct: "getMyProduct",
  getProductById: "getProduct",
  updateProduct: "updateProduct",
  deleteProduct: "deleteProduct",
  reportProduct: "reportProduct",

  //address
  addAddress: "addAddress",
  getMyAddress: "getMyAddress",
  updateAddress: "updateAddress",
  deleteAddress: "deleteAddress",
  selectAddress: "selectAddress",

  //cms
  cms: "cms",
  faq: "faq",
  review: "review",
  report: "reportUser",
  getBoosterPlans: "getBoosterPlans",
  buyBooster: "buyBooster",
  getMyBoosterPlan: "getMyBoosterPlan ",
  notification: "notification",

  //chat
  chatList: "chatList",
  clearChat: "clearChat",
  offerResponse: "offerResponse",

  //payment
  saveCard: "saveCard",
  getCard: "getCard",
  deleteCard: "deleteCard",

  //statesList
  statesList: "statesList",
  selectState: "selectState",

  //categoryFilter
  getMyProductFilter: "getMyProductFilter",
  searchOnNextPage: "searchOnNextPage",
  relatedProducts: "relatedProducts",
  sellerForm: "sellerForm",
  getSeller: "getSeller",
  mostlyViewed: "mostlyViewed",
  mostlySearched: "mostlySearched",
  newArrival: "newArrival",

  //seller
  sellerSendOtp: "sellerSendOtp",
  sellerVerifyotp: "sellerVerifyotp",

  //blogs
  blogs: "wp-json/custom/v1/blogs",
  seasonalOffers: "wp-json/custom/v1/page",
  blogsByCategory: "wp-json/custom/v1/categoryblog",
  blogById: "wp-json/custom/v1/blog",
  topManufacturers: "wp-json/custom/v1/manufacturers",

  topDeals: "topDeals",
  hotDeals: "hotDeals",
};
